import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { message, Button, Select, Row, Col, Upload } from 'antd';
import { NHModal } from '../../common/NHModal';
import { hasAuth } from "../../../utils/NHCore";
import NHFetch from "../../../utils/NHFetch";
import { query, post } from '../../../utils/request';

/**
 * 人脸识别信息查询 
 */

function beforeUpload(file) {
    
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJPG) {
            message.error("You can only upload JPG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error("Image must smaller than 10MB!");
        }
        return isJPG && isLt2M;
    }

export default class ScjtRlsbxxcx extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            titleModal:"",//弹窗标题
            initParams: {},
            selectKey: '',
            columns: [],
            xsid: null,
            flag: false,
        }
    }

    // 准备识别库头像信息
    getEnrollPhoto = async (userId) => {
        try {
            const res = await query('/api/zhxg-yxwz/openapi/student/getStudentPhotoBase64', { xsid: userId, type: 10 })
            if (!res || res.code != 200) {
                message.error('图片资源请求异常,请联系管理员!')  
            } else {
                this.setState({
                    enrollPhoto: res.data
                })
            }
        } catch (error) {
            console.log('测试:', error)
            return error
        }
    }

    handleUploadBtnClick = (record) => {
        this.getEnrollPhoto(record.PKID);
        this.setState({
            titleModal: "对比学生照片",
            xsid: record.PKID,
        },() =>{
            this.refs.uploadModal.show();
        })
        
    }

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    // 上传图片
    handleUploadChange = (info) => {
        this.refs.uploadModal.stopLoading();
        this.getBase64(info.file.originFileObj, imageUrl =>
            this.setState({ 
                flag: false,
                imageUrl,
             })
        );
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel(' 人脸识别信息');
    }

    cancelModal = () => {
        this.setState({
            imageUrl: null,
            xsid: null,
            enrollPhoto: null,
            flag: false,
        })
    }

    stareCompareFace = async () => {
        this.refs.uploadModal.stopLoading();
        const { imageUrl, xsid, enrollPhoto } = this.state;
        if(imageUrl) {
            const comparePhoto = imageUrl.replace(/^data:image\/\w+;base64,/, "");//去掉base64位头部
            const params1 = {
                image: comparePhoto,
                image_type: 'BASE64'
            };
            const params2 = {
                image: enrollPhoto,
                image_type: 'BASE64'
            };
            const params = [params1, params2];
            const res = await post('/api/zhxg-yxxt/yxwz/rlsb/baiduFeatureCompare', params)
            console.log('对比对比响应结果:', res)
            if (res && res.error_msg == "SUCCESS") {
                let { score } = res.result;
                if (score >= 80) {
                    message.success("认证成功");
                    this.setState({ 
                        flag: true,
                        score: score.toFixed(2) + '%',
                        comparePhoto: comparePhoto, 
                    });
                }else {
                    message.warn('对比失败<准确度不足>，请重新上传!')
                }
            } else if (res && res.error_msg == "pic not has face") {
                message.warn('对比失败<不是人脸>，请重新上传!');
                this.setState({ flag: false });
            } else if(res && res.error_msg ==  "param[image] is null"){
                message.warn('找不到该生的录取照片，请先确认录取照片是否存在!');
                this.setState({ flag: false });
            } else {
                message.warn('系统错误，请联系管理员!');
                this.setState({ flag: false });
            }
        }else {
            message.warn('请上传对比照片！')
        }
    }

    saveCompareFaceResult = () => {
        //认证成功才执行下面
        const { xsid, flag, score, comparePhoto } = this.state;
        if(flag) {
            const param = {
                score: score,
                photo: comparePhoto
            }
            NHFetch('/yxwz/rlsb/saveOrUpdateStuFaceCompareResult?xsid=' + xsid, 'POST',  param)
            .then(res => {
                if (!res || res.code != 200) {
                    message.error('系统繁忙,请联系管理员!')
                }else {
                    message.success("保存认证结果成功！")
                    this.refs.uploadModal.close();
                    this.refs.nhTable.filterTableData();
                    this.setState({
                        imageUrl: null,
                        xsid: null,
                        enrollPhoto: null,
                        flag: false,
                    })
                }
            })
        }else {
            this.refs.uploadModal.stopLoading();
            message.warn("请上传照片并对比通过！")
        }
      }

    render() { 
        const columns = [
            {
                title: '序号',
                key: 'ROW_ID',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                key: 'XH',
                dataIndex: 'XH',
                width: '80px',
                searchType: "input"
            }, {
                title: '姓名',
                key: 'XM',
                dataIndex: 'XM',
                width: '80px',
                searchType: "input"
            }, {
                title: '性别',
                key: 'XB',
                dataIndex: 'XB',
                width: '60px',
                search: 'select',
                searchType: "select"
            }, {
                title: '年度',
                key: 'ND',
                width: '60px',
                dataIndex: 'ND',
                searchType: "select"
            }, {
                title: '身份证号',
                key: 'SFZJH',
                dataIndex: 'SFZJH',
                width: '100px',
                searchType: "input"
            }, {
                title: '出生日期',
                key: 'CSRQ',
                width: '60px',
                dataIndex: 'CSRQ',
                searchType: "input"
            }, ,{
                title: '学院名称',
                width: '120px',
                dataIndex: 'BMMC',
                key: 'BMMC',
                searchType:"select"
            }, {
                title: '专业名称',
                width: '120px',
                dataIndex: 'ZYMC',
                key: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级名称',
                width: '120px',
                dataIndex: 'BJMC',
                key: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '认证结果',
                key: 'RZJG',
                width: '80px',
                dataIndex: 'RZJG',
                searchType: "select"
            }, {
                title: '录取照片比对值（与现场人脸）',
                key: 'LQZPPBDZ',
                width: '90px',
                dataIndex: 'LQZPPBDZ',
                searchType: "input"
            }] 

        const { imageUrl } = this.state;
        const actions = [
            {title: '上传比对', onClick: this.handleUploadBtnClick, auth: 'xmd_zhxg_yxgl_rlsb_upload'}
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div style={{width: '100%', height: '100%',}}> 
                        <NHTable
                            ref='nhTable'
                            rowKey={record => record.PKID}
                            sign={"zhxg_yxxt_rlsb_xxcx_scjt"}
                            columns={columns}
                            rangeFilter={true}
                            action={actions}
                        > 
                        {
                            hasAuth("zhxg_yxgl_tjcx_rlsb_xxcx:export") && 
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{marginLeft: 10}}>导出</Button>
                        }
                        </NHTable>  
                </div>
                <NHModal ref="uploadModal"
                        title={this.state.titleModal}
                        width={350}
                        height={600}
                        onOk={this.saveCompareFaceResult}
                        destroyOnClose={true}
                        onCancel={this.cancelModal}
                    >
                    <div className="photoIcon">
                            <Upload
                                name="photo"
                                accept={'image/*'}
                                showUploadList={false}
                                beforeUpload={beforeUpload}
                                onChange={this.handleUploadChange}
                            >
                                {imageUrl ? (
                                        <img
                                            src={imageUrl}
                                            alt=""
                                            style={{width:'140px',height:'170px'}}
                                        />
                                ) : (
                                        <div className="upload-box">
                                            <div className="upload-title">
                                                上传图片
                                        </div>
                                        </div>
                                    )}
                            </Upload>
                        
                    </div>
                    <Button type="primary" ghost onClick={this.stareCompareFace} style={{margin: '15px 0 0 12px',left: '32%'}}>开始对比</Button>
                </NHModal>
                <style jsx="true" global="true">
                        {`
                            .photoIcon{
                                position: relative;
                                width: 140px;
                                height: 170px;
                                background-color: #f2f2f2;
                                left: 27%;
                            }
                            
                            .upload-box{
                                position: relative;
                                height: 100%;
                                width: 100%;
                            }
                            
                            .upload-title{
                                width: 140px;
                                height: 170px;
                                line-height: 170px;
                                text-align: center;
                                color: #0273fd;
                            }
                        `}
                    </style>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/tjcx/scjtRlsbxxcx/index.js